import { Carousel } from '@design-system';
import chunk from 'lodash.chunk';
import Link from 'next/link';
import { FC } from 'react';

interface Props {
  handleClick: (term: string) => void;
  handleSlide: (index: number) => void;
  items: {
    full_slug: string;
    name: string;
  }[];
  listLength?: number;
  title?: string;
}

export const GlossaryCarousel: FC<Props> = ({
  handleClick,
  handleSlide,
  items,
  listLength = 8,
  title,
}) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <Carousel
      headline={title}
      items={chunk(items, listLength).map((list) => (
        <div key={list[0].name} className="flex flex-col gap-3 md:gap-2">
          {list.map((entry) => (
            <Link
              key={entry.name}
              className="link"
              href={`/${entry.full_slug}`}
              onClick={() => handleClick(entry.name)}
            >
              {entry.name}
            </Link>
          ))}
        </div>
      ))}
      onSlide={handleSlide}
    />
  );
};
